export enum DocumentType {
    InvoiceProforma = 'INV',
    ClientOrder = 'CO',
    CreditNote = 'CREDIT',
}
